import Icon from "@/components/Icon"
import BootstrapButton from "@/components/form/BootstrapButton"
import type { IncidentLocation } from "@/models/IncidentLocation"
import { LatLngFormatType, formatLatLngPart } from "@/utils/formatting/formatLatLng"
import { faLocationDot } from "@fortawesome/free-solid-svg-icons"
import { computed, toRef } from "vue"
import { defineComponent, inferProps, proxyProp, type ReactiveComponent } from "vue-utils"
import { useIncidentHandler } from "../../IncidentLogHandler"
import { generateMarkerFilter } from "./generateMarkerFilter"
import MarkerImg from "/leaflet/marker-icon.png"

interface Props {
	index: number
	location: IncidentLocation

	openOnMap(): void
}

const AdditionalLocationsRow: ReactiveComponent<Props> = (props) => {
	const handler = useIncidentHandler()

	const location = proxyProp(props, "location")
	const receivedDate = toRef(() => location.receivedAt)

	const dateFormatted = computed(() => {
		const time = receivedDate.value
		if (!time) {
			return handler.readOnly ? "-" : ""
		}
		return handler.formatTime(time)
	})

	const filter = computed(() => generateMarkerFilter(props.index + 1))

	return () => (
		<tr key={location.id}>
			<td title={`Additional Incident Location ${props.index + 1}`}>
				<img alt="" src={MarkerImg} style={{ width: "1.1em", filter: filter.value }} />
				<span>{props.index + 1}</span>
			</td>
			<td title="Latitude">
				<span>{formatLatLngPart(location.position.latitude, "latitude", LatLngFormatType.DegreesDecimalMinutes)}</span>
			</td>
			<td title="Longitude">
				<span>
					{formatLatLngPart(location.position.longitude, "longitude", LatLngFormatType.DegreesDecimalMinutes)}
				</span>
			</td>
			<td title={location.receivedAt.toUTCDateTimeString()}>{dateFormatted.value}</td>
			<td>
				<BootstrapButton color="danger" onClick={() => props.openOnMap()}>
					<Icon icon={faLocationDot} />
					View on Map
				</BootstrapButton>
			</td>
		</tr>
	)
}

export default defineComponent(AdditionalLocationsRow, inferProps<Props>())
